import { createContext, useContext } from 'react';
export const TrackUsageContext = /*#__PURE__*/createContext(() => {});
export const useTrackUsageContext = () => useContext(TrackUsageContext);
export const usageTrackerAdapter = tracker => config => tracker && tracker.track(config.key, config.properties);
TrackUsageContext.displayName = 'TrackUsageContext';